/// <reference path="./pages/Evidently.tsx"/>
// entry point for bundling

if (module.hot) {
	module.hot.accept()
	module.hot.dispose(() => {
		document.getElementById('main').innerHTML = ''
	})
}
import './vendor'
import './app/setup-env'
import './styles/reset.css'
import './styles/entry.css'
import './pages/covidStats'

const EvidentlyPage = require('./pages/Evidently')
//document.body.append(EvidencePage.default)

//Doc.runTests = () => import('test/entrypoint')
